"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AppProvider_1 = require("../../components/AppProvider");
var helpers_1 = require("../helpers");
function compile(appRootElement, providers, onRender) {
    var element = helpers_1.constructElement(providers, appRootElement);
    var dependencies = helpers_1.collectDependencies(providers);
    return onRender(React.createElement(AppProvider_1.AppProvider, { context: dependencies }, element), dependencies);
}
exports.compile = compile;
//# sourceMappingURL=compile.js.map